import { useEffect, useState } from "react";
import { tickerItems } from "@/mocks/headlines";

const navItems = [
  { label: "今日焦点", href: "#focus" },
  { label: "追更时间线", href: "#timeline" },
  { label: "实锤讨论", href: "#discussion" },
  { label: "反转复盘", href: "#review" },
  { label: "全网热榜", href: "#hotrank" },
  { label: "专题合集", href: "#topics" },
  { label: "后续进展", href: "#followup" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="sticky top-0 z-50">
      {/* 滚动资讯条 */}
      <div className="bg-foreground-950 text-background-50">
        <div className="mx-auto flex max-w-7xl items-center gap-3 overflow-hidden px-4 py-2">
          <span className="flex shrink-0 items-center gap-1.5 bg-primary-500 px-2 py-0.5 text-xs font-semibold whitespace-nowrap">
            <i className="ri-fire-fill text-sm" />
            快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-ticker flex w-max items-center gap-10">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="flex items-center gap-2 text-xs whitespace-nowrap">
                  <i className="ri-circle-fill text-[6px] text-accent-500" />
                  {t}
                </span>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-300 sm:flex">
            <i className="ri-time-line" /> 2026-09-06
          </span>
        </div>
      </div>

      {/* 主站头 */}
      <header
        className={`border-b border-background-200 bg-background-50/95 backdrop-blur transition-all ${
          scrolled ? "shadow-none" : ""
        }`}
      >
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex items-center justify-between py-3 md:py-4">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-10 w-10 items-center justify-center bg-primary-500 text-lg font-bold text-background-50">
                <i className="ri-eye-off-fill text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-2xl font-black tracking-tight">9黑料网</span>
                <span className="mt-1 text-[10px] tracking-[0.2em] text-foreground-500">
                  深挖 · 实锤 · 时间线 · 复盘
                </span>
              </span>
            </a>

            <div className="hidden items-center gap-2 md:flex">
              <div className="flex items-center gap-1 rounded-md border border-background-200 bg-background-50 px-2.5 py-2">
                <i className="ri-search-line text-sm text-foreground-400" />
                <input
                  className="w-36 bg-transparent text-sm outline-none placeholder:text-foreground-400"
                  placeholder="搜事件 / 人物"
                />
                <i className="ri-close-circle-fill hidden text-sm text-foreground-300" />
              </div>
              <a
                href="#topics"
                className="flex items-center gap-1.5 rounded-md border border-primary-200 bg-primary-50 px-3 py-2 text-sm font-medium whitespace-nowrap text-primary-700 hover:bg-primary-100"
              >
                <i className="ri-send-plane-line" /> 线索投稿
              </a>
              <a
                href="#followup"
                className="flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-2 text-sm font-semibold whitespace-nowrap text-background-50 hover:bg-primary-600"
              >
                追更订阅
              </a>
            </div>

            <button
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 md:hidden"
              aria-label="菜单"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
            </button>
          </div>

          {/* 导航 */}
          <nav className="hidden items-center gap-1 border-t border-background-200 py-1.5 lg:flex">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="rounded-full px-3 py-1.5 text-sm font-medium whitespace-nowrap text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950"
              >
                {n.label}
              </a>
            ))}
            <span className="ml-auto flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-radar-line text-accent-600" />
              今日已有 <b className="text-accent-700">37</b> 个事件进入追踪
            </span>
          </nav>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-2 lg:hidden">
            <div className="flex flex-col gap-1">
              {navItems.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-secondary-100"
                >
                  {n.label}
                </a>
              ))}
            </div>
          </nav>
        )}
      </header>
    </div>
  );
}